import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OmniSharedUiModule } from '@cigna/omni/shared';
import { UI_COMPONENTS } from './ui';
import { CommChannelCheComponent } from './che/che.component';
import { CommChannelSupportComponent } from './support/support.component';
import { MyConversationsCardComponent } from './my-conversations-card/my-conversations-card.component';
import { OmniConversationsStateModule } from '@cigna/omni/conversations-state';
import { OmniConversationSummaryCardModule } from '@cigna/omni/conversation-summary-card';
import { UiButtonModule } from '@cigna/ui/button';
import { CommChannelEapComponent } from './eap/eap.component';

@NgModule({
  imports: [
    CommonModule,
    OmniConversationsStateModule,
    OmniConversationSummaryCardModule,
    UiButtonModule,
    OmniSharedUiModule,
  ],
  declarations: [
    ...UI_COMPONENTS,
    CommChannelCheComponent,
    CommChannelSupportComponent,
    CommChannelEapComponent,
    MyConversationsCardComponent,
  ],
  exports: [
    ...UI_COMPONENTS,
    CommChannelCheComponent,
    CommChannelSupportComponent,
    CommChannelEapComponent,
    MyConversationsCardComponent,
  ],
})
export class OmniCommChannelFeatureModule {}
